import * as React from 'react';
import * as S from './styles';

export interface CommonButtonInterface
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: any;
  onClick?: () => void;
  gtmLabel?: string | boolean;
  disabled?: boolean;
  propCss?: any;
}

function Button({
  children,
  onClick,
  gtmLabel = '',
  ...rest
}: CommonButtonInterface) {
  return (
    <S.Button onClick={onClick} data-gtm-label={gtmLabel} {...rest}>
      {children}
    </S.Button>
  );
}

export default Button;
